import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('fr');

  const toggleLanguage = useCallback(() => {
    setLanguage((prev) => (prev === 'fr' ? 'en' : 'fr'));
  }, []);

  const t = useCallback(
    (obj) => {
      if (!obj || typeof obj !== 'object') return '';
      const value = obj[language];
      if (Array.isArray(value)) {
        return value.length ? value : obj.fr || [];
      }
      if (typeof value === 'string') {
        return value.trim() ? value : obj.fr || '';
      }
      if (value !== undefined && value !== null) return value;
      return obj.fr || '';
    },
    [language]
  );

  const value = useMemo(
    () => ({ language, toggleLanguage, t }),
    [language, toggleLanguage, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}
